module.exports = __webpack_public_path__ + "img/fa-book.b866764.svg";